var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"main"},[_c('div',{staticStyle:{"position":"relative"}},[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/image/develop.png"),"alt":""}}),_c('div',{staticClass:"tip"},[_vm._v("抱歉，页面升级中，点击 "),_c('span',{on:{"click":_vm.backPage}},[_vm._v("返回上一页")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }